import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { CompanyService } from '../../service/company.service';
import { Observable, mergeMap, take, tap } from 'rxjs';
import { Company } from 'src/app/lem/models/companies/company';
import { Pathbar } from 'src/app/lem/models/common/pathbar';


@Component({
  selector: 'app-detail-company',
  templateUrl: './detail-company.component.html',
  styleUrls: ['./detail-company.component.css'],
  host: { '[attr.id]': '\'content\'' }
})
export class DetailCompanyComponent implements OnInit {

  company: Company;
  pathbars: Pathbar[] = [];


  constructor(
    private viewManager: ViewManagerService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
  ) {}


  ngOnInit(): void {
    this.viewManager.svuotaMenu();
    this.populateCompany().subscribe(res => this.populatePathbar());
  }

  populateCompany(): Observable<Company> {
    return this.route.params.pipe(
      take(1),
      mergeMap((params) => {
        return this.companyService.findById(params['id']);
      }),
      tap((company: Company) => this.company = company),
    );
  }

  private populatePathbar() {
    this.pathbars.push({ path: "/gestionesocieta", title: "Vai alla gestione società", description: "Società" });
    this.pathbars.push({ path: "/gestionesocieta/dettaglio/" + this.company?.id, title: "", description: "Gestione società" });
  }
}
